import { HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { Company } from '@skylab-shared/dataModel';

export type UploadImageResult = {
    url: string;
};

export type UploadImageFailure = {
    errors?: UploadImageErrors[];
};

export type UploadImageErrors =
    | 'NotSupportedImageFormat'
    | 'InvalidImageResolution';

export class CompanyRepositoryBase {
    public constructor(
        private readonly http: HttpService) {
    }

    public async findAsync(): Promise<Company> {
        const response = await this.http.sendRequest({
            method: 'GET',
            url: '[api] myCompany'
        });
        const item = this.fromPlainObjectAsync(response.data);
        return item;
    }

    protected async fromPlainObjectAsync(item: any): Promise<Company> {
        const model = {
            address: item.address,
            city: item.city,
            countryId: item.countryId,
            email: item.email,
            name: item.name,
            nip: item.nip,
            nipue: item.nipUe,
            phoneNumber1: item.phoneNumber1,
            phoneNumber2: item.phoneNumber2,
            regon: item.regon,
            zipCode: item.zipCode,
            website: item.website
        };
        return model;
    }

    public async refreshCompanyAsync(): Promise<any> {
        const response = await this.http.sendRequest({
            method: 'POST',
            url: '[api] myCompany/refresh'
        });
        const item = this.fromPlainObjectAsync(response.data);
        return item;
    }

    public async uploadLogoAsync(fd: FormData): Promise<UploadImageResult> {
        const response = await this.http.sendRequest<UploadImageResult>({
            method: 'POST',
            url: TaggedUrl.join('myCompany/properties/logo', [Tags.Api]),
            data: fd,
            withCredentials: true,
            headers: { 'Content-Type': undefined },
            transformRequest: []
        });
        return response.data;
    }

    public async uploadAppBackgroundAsync(fd: FormData): Promise<UploadImageResult> {
        const response = await this.http.sendRequest<UploadImageResult>({
            method: 'POST',
            url: TaggedUrl.join('user/background', [Tags.Api]),
            data: fd,
            withCredentials: true,
            headers: { 'Content-Type': undefined },
            transformRequest: []
        });
        return response.data;
    }
}
